import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import colorWheel from '../../Theme/ColorWheel';

const styles = StyleSheet.create(
    {
        tab: { marginTop: 30, marginLeft: 10, marginRight: 10, width: "100%" },
        title: { fontSize: 12, borderBottom: '1 solid #747679', width: '95%', fontFamily: "RobotoRegular", color: '#373534' },
        row: { marginTop: 5, marginLeft: 30, fontSize: 10, fontFamily: "RobotoRegular", display: "flex", flexDirection: "row" },
        section: { marginTop: 10, marginLeft: 20 },
        label: { width: "40%", textAlign: "right", marginRight: 10, color: colorWheel.graniteGrey },
        value: { width: "45%" },
    }
)

const BerkeleyServiceBrand = props => {
    const { services, brand } = props;
    console.log(services);
    const serviceText = services.map(s => s.name).join(',');

    return <View style={styles.tab}>
        <Text style={styles.title}>Selected Brand & Services</Text>
        <View style={styles.section} wrap={false}>
            <View style={styles.row}>
                <Text style={styles.label}>Brand</Text>
                <Text style={styles.value}>{brand}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.label}>Services</Text>
                <Text style={styles.value}>{serviceText}</Text>
            </View>
        </View>
    </View>
}

export default BerkeleyServiceBrand;
